export const RAW_TIMLINE1 = [
  {
    1: '2025-11-13T09:57:09.321747+01:00',
    2: '2025-11-18T10:57:09.321747+01:00',
    regmail_tracking_id: null,
  },
]

export const RAW_TIMLINE2 = [
  {
    1: '2025-11-13T09:57:09.321747+01:00',
    2: '2025-11-13T10:57:09.321747+01:00',
    3: '2025-11-13T11:57:09.321747+01:00',
    7: '2025-11-13T12:57:09.321747+01:00',
    regmail_tracking_id: null,
  },
]

export const RAW_TIMLINE3 = [
  {
    7: '2025-11-13T12:57:09.321747+01:00',
    regmail_tracking_id: null,
  },
]

export const RAW_TIMLINE_WITH_TRACKING_ID = [
  {
    1: '2025-11-13T09:57:09.321747+01:00',
    2: '2025-11-13T10:57:09.321747+01:00',
    3: '2025-11-13T11:57:09.321747+01:00',
    6: new Date(),
    regmail_tracking_id: 'AB0123456789',
  },
]

export const EPOST_RECIPIENT = {
  archived: false,
  avatar:
    'https://files.idwell.at/kucherkova.qa.idwell.at/v2/thumbnails/170X170/kucherkova.qa.idwell.at/private/2023/03/5d03a694-fdca-4970-97b5-864d303535bb.png',
  avatar_color: '#A337EA',
  email: 'olga.kucherkova+uchiha@idwell.com',
  fullname: 'Itachi Uchiha',
  id: 13665,
  role: 'landlord',
  status: 1,
}
